import { STATUS_BADGE_CLASS, STATUS_LABEL, STATUS_NEXT } from '../lib/aktivitaet.js';

/**
 * Klickbare Status-Pille — schaltet beim Klick zum nächsten Status weiter
 * (offen → in_bearbeitung → erledigt → offen).
 */
export default function AktivitaetStatusBadge({ status, onChange, disabled }) {
  const baseClass =
    'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset';
  const colorClass = STATUS_BADGE_CLASS[status] ?? 'bg-slate-100 text-slate-700 ring-slate-200';

  function handleClick(event) {
    event.stopPropagation();
    if (disabled || !onChange) return;
    const next = STATUS_NEXT[status] ?? 'offen';
    onChange(next);
  }

  if (!onChange) {
    return <span className={`${baseClass} ${colorClass}`}>{STATUS_LABEL[status] ?? status}</span>;
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      title="Status weiterschalten"
      className={`${baseClass} ${colorClass} transition hover:brightness-95 disabled:cursor-not-allowed disabled:opacity-60`}
    >
      {STATUS_LABEL[status] ?? status}
    </button>
  );
}
